// extracted by mini-css-extract-plugin
export default {"switchContainer":"Switch_switchContainer__b9rgw","disabled":"Switch_disabled__YQQoo","switch":"Switch_switch__uo5pw"};